import React from 'react';

function Copy(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 18 18">
            <path
                d="M5 2h7.8c1.11 0 1.51.12 1.92.33.4.22.73.54.95.95.21.4.33.81.33 1.93V13a1 1 0 0 0 2 0V5.13c0-1.79-.19-2.43-.53-3.08A3.63 3.63 0 0 0 15.95.53C15.3.2 14.65 0 12.87 0H5a1 1 0 1 0 0 2Zm7.72 2.33c-.4-.21-.81-.33-1.93-.33H3.21c-1.12 0-1.52.12-1.93.33-.4.22-.73.55-.95.95-.21.4-.33.81-.33 1.92v7.6c0 1.1.12 1.51.33 1.92.22.4.54.73.95.95.4.21.81.33 1.93.33h7.58c1.12 0 1.52-.12 1.93-.33.4-.22.73-.54.95-.95.21-.4.33-.81.33-1.92V7.2c0-1.11-.12-1.51-.33-1.92-.22-.4-.55-.73-.95-.95Z"
                fill={props.color}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default Copy;
